// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"686":"641a047c","787":"c2f78e20"}[chunkId] + ".chunk.js";
};